import React from 'react';
import PropTypes from 'prop-types';
import TextArea from '@tds/core-text-area';
import Tooltip from '@tds/core-tooltip';

import { InputTitle, InputWrapper } from './css';
import Note from '../../note';
import formFieldOperationOptions from '../../utils/formFieldOperationOptions';

const FieldMultiLineText = ({ data }) => {
  const {
    ref,
    name,
    label,
    value,
    title,
    required,
    onChange,
    placeholder,
    tooltip,
    note,
    disabled,
    noteAppearsBelowField,
    isShowNoteBackground,
    isColorRed
  } = data;
  const renderNotes = () => {
    return (
      note &&
      note.content && (
        <Note
          type="richText"
          options={formFieldOperationOptions(value)}
          data={note}
          isShowNoteBackground={isShowNoteBackground}
          isColorRed={isColorRed}
        />
      )
    );
  };

  return (
    <>
      {note && note.content && !noteAppearsBelowField && renderNotes()}
      {title && <InputTitle>{title}</InputTitle>}
      <InputWrapper>
        <span className="frg-body-font-14px" style={{ display: 'inline-flex' }}>
          {label}
          {required && `*`}
          {tooltip && (
            <span style={{ paddingLeft: '5px' }}>
              <Tooltip copy="en">{tooltip}</Tooltip>
            </span>
          )}
        </span>
        {note && note.content && noteAppearsBelowField && renderNotes()}
        <TextArea
          ref={ref}
          id={name}
          name={name}
          value={value}
          disabled={disabled}
          placeholder={placeholder}
          onChange={onChange}
        />
      </InputWrapper>
    </>
  );
};

FieldMultiLineText.propTypes = {
  data: PropTypes.shape({
    ref: PropTypes.object,
    isColorRed: PropTypes.bool,
    placeholder: PropTypes.string,
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    value: PropTypes.string,
    title: PropTypes.string,
    required: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    tooltip: PropTypes.string,
    note: PropTypes.shape({
      content: PropTypes.arrayOf(PropTypes.object)
    }),
    noteAppearsBelowField: PropTypes.bool.isRequired
  }).isRequired
};

export default FieldMultiLineText;
